import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { errorCss } from '../../ui/Form/baseStyles/index.styles';
import { Edges, VIEWPORTS } from '../../../styles/Grid/GridSizes';

export const cardsectioncolumn = css({
  [MediaQueries.xl]: { paddingLeft: '24px', paddingRight: '24px' },
});

export const cardsection = css({
  background: colorsPalette.white,
  padding: '24px',
  borderRadius: '8px',
  [MediaQueries.md]: {
    maxWidth: 'unset',
    padding: '40px',
    marginBottom: '16px',
    ':lastChild': { marginBottom: '0px' },
  },
  [MediaQueries.lg]: {
    maxWidth: 'unset',
    marginBottom: '24px',
    padding: '40px',
    ':lastChild': { marginBottom: '0px' },
  },
  [MediaQueries.sm]: {
    maxWidth: 'unset',
    marginBottom: '16px',
    ':lastChild': { marginBottom: '0px' },
  },

  h4: {
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0px',
    fontWeight: '500',
    textAlign: 'left',
    marginTop: '32px',
    marginBottom: '12px',
    [MediaQueries.lg]: { display: 'none' },
    [MediaQueries.md]: { display: 'none' },
    [MediaQueries.sm]: { display: 'none' },
  },
});
export const shop_overlay_mid = css({
  padding: '48px 0px 48px 0px',
  [MediaQueries.sm]: { padding: '24px 0px 9px 0px' },
  [MediaQueries.md]: { padding: '48px 0px 26px 0px' },
  [MediaQueries.lg]: { padding: '44px 0px 28px 0px' },
});

export const shop_overlay_midcolumn = css({
  [MediaQueries.sm]: {},
  [MediaQueries.md]: {},
  [MediaQueries.xl]: { paddingLeft: '0px', paddingRight: '0px' },
});

export const decision_form = css({
  [MediaQueries.sm]: {},
  [MediaQueries.md]: { maxWidth: '368px', paddingTop: '32px' },
  [MediaQueries.lg]: { maxWidth: '368px', paddingTop: '32px' },
});

export const closeButtonCss = css({
  background: 'none',
  border: 0,
  cursor: 'pointer',
  display: 'flex',
  padding: 0,
  position: 'relative',
  width: 'auto',
  [MediaQueries.mdAndUp]: {},
  [MediaQueries.lgAndUp]: {},
  [MediaQueries.sm]: { marginTop: '0px', i: { fontSize: '12px' } },
});

export const shop_overlay_container = css({
  '.heading_sec_overlay': {
    display: 'flex',
    justifyContent: 'space-between',

    button: {
      height: '25px',
    },

    [MediaQueries.xl]: { paddingLeft: '10px', paddingRight: '10px' },

    h2: {
      fontSize: '40px',
      lineHeight: '40px',
      letterSpacing: '-0.3px',
      color: colorsPalette.black,
      fontWeight: '500',
      marginBottom: '60px',
      [MediaQueries.sm]: {
        fontSize: '32px',
        lineHeight: '32px',
        letterSpacing: '-0.4px',
        maxWidth: '202px',
        marginBottom: '48px',
      },
      [MediaQueries.md]: {
        marginBottom: '48px',
      },
      [MediaQueries.lg]: {
        marginBottom: '32px',
      },
    },

    [MediaQueries.sm]: {
      alignItems: 'end',
    },
  },
});

export const iconCss = css({
  fontSize: 18,
  marginRight: 12,
});

export const bulletList = css({
  marginTop: '24px',
  li: {
    display: 'flex',
    marginBottom: '16px',
    lineHeight: '24px',

    [MediaQueries.xl]: {
      minHeight: '48px',
      marginBottom: '24px',
    },

    '.icon_bullet': {
      marginRight: '15px',
      position: 'relative',
      top: '3px',
    },

    '.list_text': {
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
    },
  },
});
export const cardCTAButton = css({
  background: colorsPalette.red,
  borderRadius: '8px',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
  height: '56px',
  color: colorsPalette.white,
  marginTop: '60px',
  textDecoration: 'none',
  textTransform: 'uppercase',
  fontSize: '14px',
  lineHeight: '18px',
  letterSpacing: '0.875px',
  textAlign: 'center',

  ':hover': {
    background: colorsPalette.red110,
    outlineColor: colorsPalette.red110,
  },

  [MediaQueries.sm]: { marginTop: '32px' },
  [MediaQueries.md]: { maxWidth: '186px', marginTop: '32px' },
  [MediaQueries.lg]: { maxWidth: '186px', marginTop: '32px' },
});

export const modalcss = css({
  boxShadow: '0px 24px 128px rgba(57, 57, 57, 0.2)',
  borderRadius: '16px !important',
  display: 'flex',
  margin: '72px',
  marginLeft: 'auto',
  marginRight: 'auto',
  outline: '0',
  maxWidth: '1296px',
  [MediaQueries.md]: {
    height: '100vh',
    margin: '0px auto',
    borderRadius: '0px !important',
    boxShadow: 'none',
    overflowY: 'auto',
    outline: '0',
  },
  [MediaQueries.lg]: {
    height: '100vh',
    margin: '0px auto',
    borderRadius: '0px !important',
    boxShadow: 'none',
    overflowY: 'auto',
  },

  [MediaQueries.sm]: {
    height: '100vh',
    margin: '0px auto',
    borderRadius: '0px !important',
    boxShadow: 'none',
    overflowY: 'auto',
  },
});

export const modalContent = { background: colorsPalette.brown10 };
export const overlayProp = {
  background: 'transparent',
  backdropFilter: 'blur(5px)',
  display: 'flex',
  alignItems: 'center',
  [MediaQueries.xl]: {
    display: 'flex',
    alignItems: 'center',
  },
};

export const headTitle = css({
  h3: {
    display: 'inline',
    fontSize: '22px',
    lineHeight: '24px',
    letterSpacing: '-0.4px',
    color: colorsPalette.black,
    fontWeight: '500',
  },
  'h3:first-child': {
    span: {
      color: colorsPalette.teal,
    },
  },
});
export const hideBulletListLG = css({
  [MediaQueries.xl]: {
    display: 'none',
  },
});
